/*global ORG_NAME, PROJECT_NAME */
import { windowGlobal } from './windowGlobal'

const getErrorObject = error =>
  Object.getOwnPropertyNames(error).reduce((acc, curr) => {
    acc[curr] = error[curr]
    return acc
  }, {})

const getLogs = () => {
  return windowGlobal()?.DD_LOGS
}

const getRum = () => {
  return windowGlobal()?.DD_RUM
}

const getCreateLogger = name => {
  let logger = getLogs()?.getLogger?.(name)

  if (!logger) {
    logger = getLogs()?.createLogger?.(name, {
      level: 'debug',
      context: {
        service: name,
        host: window.location.host,
      },
    })
  }

  return {
    error: (err, payload) => {
      if (err instanceof Error) {
        const { message, ...errorPayload } = getErrorObject(err)
        getRum()?.addError?.(err)
        logger.error(message, { payload, errorPayload })
        return
      }

      logger?.error?.(err, { payload })
    },
    info: (message, payload) => {
      logger?.info?.(message, { payload })
    },
  }
}

export const getLogger = () => {
  return getCreateLogger(`@${ORG_NAME}/${PROJECT_NAME}`)
}
